"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
let AccessDevices = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/application_handler_list")
    );
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.gridController.pagePosition = "dialog";
        this.gridController.query.params = {
          search: {
            "status": "pass",
            "user_id": this.user_id,
            "apply_start_time": -1,
            "apply_end_time": -1
          }
        };
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
};
__decorateClass([
  PropSync("userId")
], AccessDevices.prototype, "user_id", 2);
AccessDevices = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], AccessDevices);
export {
  AccessDevices as default
};
